import { MerchantServiceApiFactory } from '@layup/api-sdk';
import { createLayupClient } from './layupApiClient';

export const merchantServiceClient = () => {
  const client = createLayupClient();
  return MerchantServiceApiFactory(undefined, undefined, client);
};

export const getShops = async () => {
  const response = await merchantServiceClient().merchantServiceGetShopsV2();
  return response.data;
};
